import React from 'react'

import {Modal, P, Button, ProgressBar} from '../UI/index.js'
import {formSpacing, FormStack, RadioButton} from '../UI/forms/index.js'
import {AlertStack, ModalActions, ModalHeader} from '../UI/overlays/index.js'
import dbCodes from '../../../server/dbCodes.js'

export default class ChangeParcelStatusPopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            loading: false,
            newStatus: undefined,
            progressNow: 0,
            progressMax: null,
            message: '',
            error: '',
            errors: []
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(onChange) {
        this.setState({isOpen: true, onChange})
    }

    close() {
        this.setState(this.initialState)
    }

    onStatusChange(event) {
        this.setState({newStatus: event.target.value})
    }

    onSave() {
        const {newStatus, onChange} = this.state

        // Until the caller shows the result (setMessage, setError, setErrors)
        this.setState({loading: true})
        onChange(newStatus)
    }

    setMessage(message) {
        this.setState({message, loading: false})
    }

    setError(error) {
        this.setState({error, loading: false})
    }

    setErrors(errors) {
        this.setState({errors, loading: false})
    }

    setProgress(progressNow, progressMax) {
        this.setState({progressNow, progressMax})
    }

    render() {
        const {isOpen, loading, newStatus, progressMax, progressNow, message, error, errors} = this.state

        return (
            <Modal show={isOpen} style={{width: 400, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <ModalHeader style={{alignItems: 'center'}} title='Status wijzigen' onClose={this.close.bind(this)} />

                <P style={{marginBottom: 10}}>Wijzig hieronder de status van zendingen via externe vervoerders. Automatische statusupdates zullen deze status overschrijven.</P>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <RadioButton
                        label='Manco'
                        checked={newStatus === dbCodes.parcelStatus.manco()}
                        value={dbCodes.parcelStatus.manco()}
                        onChange={this.onStatusChange.bind(this)}
                    />
                    <RadioButton
                        label='Bezorgd'
                        checked={newStatus === dbCodes.parcelStatus.bezorgd()}
                        value={dbCodes.parcelStatus.bezorgd()}
                        onChange={this.onStatusChange.bind(this)}
                    />
                    <RadioButton
                        label='Retour'
                        checked={newStatus === dbCodes.parcelStatus.retour()}
                        value={dbCodes.parcelStatus.retour()}
                        onChange={this.onStatusChange.bind(this)}
                    />
                </FormStack>

                {progressMax && !message && !error &&
                    <ProgressBar style={{marginBottom: 16}} now={progressNow} max={progressMax} />
                }

                <AlertStack message={message} error={error} errors={errors} />

                <ModalActions style={{marginTop: 24}}>
                    {!message && !error &&
                        <>
                            <Button
                                onClick={this.close.bind(this)}
                                variant='text'
                            >
                                Annuleren
                            </Button>
                            <Button
                                onClick={this.onSave.bind(this)}
                                loading={loading}
                                disabled={!newStatus}
                            >
                                Opslaan
                            </Button>
                        </>
                    }

                    {(message || error) &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            Sluiten
                        </Button>
                    }
                </ModalActions>
            </Modal>
        )
    }
}
